import React from 'react';

//Material
import { Grid, Paper, Stack, Typography } from '@mui/material'; // import { Stack } from '@mui/system';
import { connect, useDispatch } from 'react-redux';

import CheckIcon from '@mui/icons-material/Check';

import '../pages/MainPage/index.css';
import { LetsGoBtn } from './Buttons';
import { setIsOpenAuthModal, setIsOpenReferralModal } from '../redux/mainReducer';
import { makePayment } from '../helpers/payments';
import ApiService from '../helpers/apiHelper';
import { useSnackbar } from 'notistack';
import { base } from '../redux/thunk'; // import  ImageGallery  from 'react-image-gallery';
// import  ImageGallery  from 'react-image-gallery';

// const useStyles = makeStyles({

//   button: {
//     '&:hover': {
//       boxShadow: '-5px 5px 3px black !important',
// width: '155px !important'
//   },
// }})
function TariffCard({
  type,
  userData,
  active,
  index,
  userSubscription,
  getPremiumSubscriptionThunk
}) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const api = new ApiService('auth/change-premium-plan');

  return (
    <Paper
      // {...props}
      // key={}
      // className="serviceCard"
      sx={{
        width: { xs: '350px', sm: '100%' },
        margin: '0px',
        textAlign: 'center',
        overflow: 'hidden',
        alignItems: 'center',
        height: '640px',
        borderRadius: '8px',
        padding: '20px 10px ',
        border: active ? '2px solid #E2F2FF !important' : 'none',
        boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
        // boxShadow: '0px 0px 15px 0px rgba(96,165,223,1)',
        backgroundColor: active ? 'white' : 'white'
        // position: 'relative',
      }}
    >
      {(type === 'THREE_MONTH_PREMIUM' || type === 'YEAR_PREMIUM') && (
        <Typography
          variant="p"
          sx={{
            fontFamily: 'FixelText-Medium !important',
            fontWeight: '500',
            fontSize: '12px',
            color: 'white',
            position: 'absolute',
            backgroundColor: '#94D086',
            p: '7px 20px',
            top: { xs: '8px', sm: '8px', md: '-15px' },
            borderRadius: '8px',
            left: { xs: 'calc(100% / 2 - 40px)', md: 'calc(100% / 2 - 50px)' }
          }}
        >
          {type === 'THREE_MONTH_PREMIUM' && 'Економія 5%'}
          {type === 'YEAR_PREMIUM' && 'Економія 7%'}
        </Typography>
      )}

      <Grid
        container
        spacing={0}
        sx={{
          width: '100%',
          margin: '0px !important',
          height: '100%',
          display: 'flex',
          alignContent: 'flex-start'
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            display: 'flex',
            justifyContent: 'start',
            flexDirection: 'column',
            alignItems: 'center',
            pb: 1,
            minHeight: '120px',
            maxHeight: '120px',
            mb: '40px'
          }}
        >
          <Typography
            variant="subtitle"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              margin: '0px',
              fontFamily: 'FixelText-Regular !important',
              fontSize: '28px',
              textAlign: 'center',
              pb: 1
            }}
          >
            {type === 'base' && 'Базовий'}
            {type === 'MONTH_PREMIUM' && 'Преміум “Місяць”'}
            {type === 'THREE_MONTH_PREMIUM' && 'Преміум “3 місяці”'}
            {type === 'YEAR_PREMIUM' && 'Преміум “Рік”'}
            {type === 'FREE_TRIAL_PREMIUM' && 'Пробний “Місяць”'}
            {/*<Typography*/}
            {/*  variant="subtitle"*/}
            {/*  sx={{*/}
            {/*    margin: '0px',*/}
            {/*    fontFamily: 'FixelText-Regular !important',*/}
            {/*    fontSize: { xs: '14px', sm: '16px' },*/}
            {/*    textAlign: 'center',*/}
            {/*    pt: 1*/}
            {/*  }}*/}
            {/*>*/}
            {/*  {type === 'base' &&*/}
            {/*    'Базовий безкоштовний тариф, який надається кожному користувачу при реєстрації'}*/}
            {/*  {type === 'MONTH_PREMIUM' &&*/}
            {/*    'Зручний тариф з щомісячною оплатою, який надає безліч переваг власникам бізнесу '}*/}
            {/*  {type === 'THREE_MONTH_PREMIUM' &&*/}
            {/*    'Зручний тариф з оплатою щоквартально, який надає безліч переваг власникам бізнесу '}*/}
            {/*  {type === 'YEAR_PREMIUM' &&*/}
            {/*    'Зручний тариф з оплатою щорічно, який надає безліч переваг власникам бізнесу '}*/}
            {/*  {type === 'FREE_TRIAL_PREMIUM' &&*/}
            {/*    'Пробний тариф, який надає можливість спробувати усі переваги власникам бізнесу '}*/}
            {/*</Typography>*/}
          </Typography>

          <Typography
            variant="subtitle"
            sx={{
              margin: '0px',
              fontFamily: 'FixelText-Regular !important',
              fontSize: '28px',
              textAlign: 'center'
            }}
          >
            {type === 'base' && 'Безкоштовно'}
            {type === 'MONTH_PREMIUM' && '780 грн '}
            {type === 'THREE_MONTH_PREMIUM' && '2223 грн '}
            {type === 'YEAR_PREMIUM' && '8704.8 грн '}
            {type === 'FREE_TRIAL_PREMIUM' && '1 грн '}
            {type === 'FREE_TRIAL_PREMIUM' && (
              <span style={{ fontSize: '20px' }}>(пробний тариф)</span>
            )}
            {type === 'MONTH_PREMIUM' && (
              <span
                style={{
                  fontFamily: 'FixelText-Medium !important',
                  fontSize: '16px',
                  mb: '10px',
                  fontWeight: '500'
                }}
              >
                (ПДВ - 130грн)
              </span>
            )}
            {type === 'THREE_MONTH_PREMIUM' && (
              <span
                style={{
                  fontFamily: 'FixelText-Medium !important',
                  fontSize: '16px',
                  mb: '10px',
                  fontWeight: '500'
                }}
              >
                (ПДВ - 370.5грн)
              </span>
            )}
            {type === 'YEAR_PREMIUM' && (
              <span
                style={{
                  fontFamily: 'FixelText-Medium !important',
                  fontSize: '16px',
                  mb: '10px',
                  fontWeight: '500'
                }}
              >
                (ПДВ - 1450.8грн)
              </span>
            )}
          </Typography>

          {type === 'THREE_MONTH_PREMIUM' && (
            <Typography
              variant="p"
              sx={{
                fontFamily: 'FixelText-Medium !important',
                fontWeight: '500',
                fontSize: '20px',
                color: '#7c7c7c'
              }}
            >
              741 грн / місяць
            </Typography>
          )}
          {type === 'YEAR_PREMIUM' && (
            <Typography
              variant="p"
              sx={{
                fontFamily: 'FixelText-Medium !important',
                fontWeight: '500',
                fontSize: '20px',
                color: '#7c7c7c'
              }}
            >
              725.4 / місяць
            </Typography>
          )}
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            display: 'flex',
            justifyContent: 'start',
            flexDirection: 'column',
            pl: '20px',
            borderTop: '1px solid lightgray'
          }}
        >
          <Stack
            spacing={1}
            sx={{
              flexDirection: 'column',
              justifyContent: type !== 'base' ? 'space-around' : 'start',
              p: type !== 'base' ? '20px 0px' : '30px 0px 20px',
              minHeight: '340px'
            }}
          >
            <Typography
              sx={{
                alignItems: 'center',
                display: 'flex',
                fontFamily: 'FixelText-Medium !important',
                fontWeight: '500',
                fontSize: '16px',
                lineHeight: '16px',
                textAlign: 'left'
              }}
            >
              <CheckIcon sx={{ fontSize: '22px', mr: 1 }} />
              {type === 'base' && '1 товар'}
              {type === 'FREE_TRIAL_PREMIUM' && '5 товарів для створення'}
              {type !== 'base' && type !== 'FREE_TRIAL_PREMIUM' && 'Необмежена кількість товарів'}
            </Typography>
            <Typography
              sx={{
                alignItems: 'center',
                display: 'flex',
                fontFamily: 'FixelText-Medium !important',
                fontWeight: '500',
                fontSize: '16px',
                lineHeight: '16px'
              }}
            >
              <CheckIcon sx={{ fontSize: '22px', mr: 1 }} />
              Історія замовлень
            </Typography>
            {type !== 'base' && (
              <Typography
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  fontFamily: 'FixelText-Medium !important',
                  fontWeight: '500',
                  fontSize: '16px',
                  lineHeight: '16px'
                }}
              >
                <CheckIcon sx={{ fontSize: '22px', mr: 1 }} />
                Календар замовлень
              </Typography>
            )}
            {type !== 'base' && (
              <Typography
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  fontFamily: 'FixelText-Medium !important',
                  fontWeight: '500',
                  fontSize: '16px',
                  lineHeight: '16px'
                }}
              >
                <CheckIcon sx={{ fontSize: '22px', mr: 1 }} />
                Доступ до бустерів
              </Typography>
            )}
            {type !== 'base' && (
              <Typography
                sx={{
                  alignItems: 'center',
                  textAlign: 'left',
                  display: 'flex',
                  fontFamily: 'FixelText-Medium !important',
                  fontWeight: '500',
                  fontSize: '16px',
                  lineHeight: '16px'
                }}
              >
                <CheckIcon sx={{ fontSize: '22px', mr: 1 }} />
                Можливість просування
              </Typography>
            )}
            {type !== 'base' && (
              <Typography
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  fontFamily: 'FixelText-Medium !important',
                  fontWeight: '500',
                  fontSize: '16px',
                  lineHeight: '16px'
                }}
              >
                <CheckIcon sx={{ fontSize: '22px', mr: 1 }} />
                Аналітика та звітність
              </Typography>
            )}

            {/* <Typography
              sx={{
                alignItems: 'center',
                display: 'flex',
                fontFamily: 'FixelText-Regular !important',
                fontSize: '14px',
                lineHeight: '16px',
                textAlign: 'left'
              }}
            >
              {type === 'base' ? (
                <CancelOutlinedIcon sx={{ fontSize: '22px', mr: 1, color: 'red' }} />
              ) : (
                <CheckIcon sx={{ fontSize: '22px', mr: 1, color: '#60A5DF' }} />
              )}
              Автоматизоване завантаження створених послуг
            </Typography> */}
            <Typography
              sx={{
                alignItems: 'center',
                display: 'flex',
                fontFamily: 'FixelText-Medium !important',
                fontWeight: '500',
                fontSize: '16px',
                lineHeight: '16px'
              }}
            >
              <CheckIcon sx={{ fontSize: '22px', mr: 1 }} />
              {type === 'base' ? 'Підтримка' : 'Преміум підтримка 24/7'}
            </Typography>
          </Stack>
        </Grid>
        {(!userData || Object.keys(userData).length === 0) && type === 'base' && (
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
            }}
          >
            <LetsGoBtn
              colorScheme="blue"
              className="service-card-btn"
              width="100%"
              margin="0px 0px 0px 0px"
              text="Приєднатися"
              onClick={() => {
                dispatch(setIsOpenAuthModal(true));
              }}
            />
          </Grid>
        )}
        {type === 'base' || active ? null : (
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
            }}
          >
            <LetsGoBtn
              disabled={userSubscription?.nextSubscriptionType === type}
              id={'joinButton' + index}
              colorScheme="blue"
              className="service-card-btn"
              width="100%"
              margin="0px 0px 0px 0px"
              text={!userSubscription?.subscriptionType ? 'Приєднатися' : 'Обрати'}
              onClick={() => {
                if (userData?.id) {
                  if (!userSubscription?.subscriptionType) {
                    makePayment(dispatch, type);
                  } else {
                    api
                      .postDataQuery({ subscriptionType: type })
                      .then((res) => {
                        enqueueSnackbar('Запит на зміну підписки оформлено', {
                          variant: 'success'
                        });
                        getPremiumSubscriptionThunk();
                      })
                      .catch((e) => {
                        enqueueSnackbar('Сталась помилка!', { variant: 'error' });
                      });
                  }
                } else {
                  dispatch(setIsOpenAuthModal(true));
                }
              }}
            />
            {type !== 'base' && !userSubscription?.subscriptionType ? (
              <Typography
                id={'referralCodeButton' + index}
                onClick={() => {
                  if (userData?.id) {
                    dispatch(
                      setIsOpenReferralModal({
                        isOpen: true,
                        type: type,
                        userId: userData?.id
                      })
                    );
                  } else {
                    dispatch(setIsOpenAuthModal(true));
                  }
                }}
                sx={{
                  fontFamily: 'FixelText-Medium',
                  fontWeight: '500',
                  fonSize: '14px',
                  textDecoration: 'none',
                  mt: 2,
                  textUnderlineOffset: '4px',
                  cursor: 'pointer',
                  color: '#60A5DF'
                }}
              >
                Маєш код від друга?
              </Typography>
            ) : null}
          </Grid>
        )}
        {/*{type === 'base' && !userData && (*/}
        {/*  <Grid*/}
        {/*    item*/}
        {/*    xs={12}*/}
        {/*    sx={{*/}
        {/*      display: 'flex',*/}
        {/*      justifyContent: 'center',*/}
        {/*      alignItems: 'center',*/}
        {/*      flexDirection: 'column'*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    <LetsGoBtn*/}
        {/*      */}
        {/*      id={'joinButton' + index}*/}
        {/*      colorScheme="blue"*/}
        {/*      className="service-card-btn"*/}
        {/*      width="100%"*/}
        {/*      margin="0px 0px 0px 0px"*/}
        {/*      text={'Приєднатися'}*/}
        {/*      onClick={() => {*/}
        {/*        dispatch(setIsOpenAuthModal(true));*/}
        {/*      }}*/}
        {/*    />*/}
        {/*  </Grid>*/}
        {/*)}*/}
      </Grid>
    </Paper>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData
  };
};
export default connect(mapStateToProps, {
  getPremiumSubscriptionThunk: base.getPremiumSubscriptionThunk
})(TariffCard);
